module.exports = __webpack_public_path__ + "img/dcc.48347fe9.png";